module.exports = __webpack_public_path__ + "static/media/tv.2b20247e.svg";